import { todoCardIds } from '../../../../pages/home-page/version2/todo-cards/todo-card-ids';
import { messages } from '../../../../pages/settings/payment-and-subscription/components/tax-identifier-information/messages';
import { CountryConfigNames } from '../../country-config-enums';
import { CountryUIFeature } from '../country-ui-feature';
import type { TaxInformationMessageData } from '../constants';
import { CountryUIConfigName } from '../constants';

export const CACountryUIConfig = [
  new CountryUIFeature(CountryConfigNames.FTUWizardHiddenTodoCards, {
    todoCardIds: [todoCardIds.FULFILLMENT],
  }),
  // TODO: [SPD-26173] Remove once enableExpandedTaxIdCountries is fully rolled out
  new CountryUIFeature(CountryUIConfigName.TaxIdUIOverride, {
    isTaxIdAvailable: 'false',
  }),
  new CountryUIFeature<TaxInformationMessageData>(CountryConfigNames.TaxInformationMessage, {
    message: messages.taxIdCAInformation,
  }),
];
